import { Dialog, DialogType } from '../../../../src/feature/narrator/narrator.model';

export const dialog: Dialog[] = [
  {
    id: 'start',
    type: DialogType.description,
    text: 'A low bathhouse sits back from the road, steam curling out under the door. A bathmaid leans in the doorway. She watches the road, then watches you, and smiles.',
    options: [
      { text: 'Step inside.', nextDialogId: 'welcome' },
      { text: 'Linger in the doorway.', nextDialogId: 'caught' },
    ],
  },
  {
    id: 'welcome',
    type: DialogType.dialog,
    text: 'Well now. The road has been hard on you, love. Come in out of the cold. I can make a new man of you.',
    options: [
      { text: 'What do you offer?', nextDialogId: 'services' },
      { text: 'Just looking, for now.', nextDialogId: 'caught' },
    ],
  },
  {
    id: 'caught',
    type: DialogType.dialog,
    text: 'See something you like, traveller? The water is warmer than the doorway, I promise you that.',
    options: [
      { text: 'Ask what she offers.', nextDialogId: 'services' },
      { text: 'Step inside, smiling.', nextDialogId: 'welcome' },
    ],
  },
  {
    id: 'services',
    type: DialogType.dialog,
    text: 'A hot bath, for a start. Or I can see to your cuts, or wash the road off your clothes. What will it be, love?',
    options: [
      { text: 'A hot bath.', nextDialogId: 'bath' },
      { text: 'Your other comforts?', nextDialogId: 'comforts' },
    ],
  },
  {
    id: 'comforts',
    type: DialogType.dialog,
    text: 'Your cuts, or your clothes. I have gentle hands for both, if you are brave enough.',
    options: [
      { text: 'Tend my cuts.', nextDialogId: 'wounds' },
      { text: 'Wash my clothes.', nextDialogId: 'laundry' },
    ],
  },
  {
    id: 'bath',
    type: DialogType.description,
    text: 'She leads you to a steaming tub and tests the water with one hand. You climb in, and the heat soaks the road out of your bones. She stays close by, humming, never quite out of sight.',
    options: [{ text: 'Let the warmth take you.', nextDialogId: 'done' }],
  },
  {
    id: 'wounds',
    type: DialogType.dialog,
    text: 'Sit, love, and let me see. This will sting. But you look like a man who can take a little pain.',
    options: [{ text: 'Gentle indeed.', nextDialogId: 'done' }],
  },
  {
    id: 'laundry',
    type: DialogType.dialog,
    text: 'Out of those, then, and I will have the mud off them by morning. Do not be shy. I have seen worse than you, love.',
    options: [{ text: 'I will wait.', nextDialogId: 'done' }],
  },
  {
    id: 'done',
    type: DialogType.dialog,
    text: 'There. Good as new, near enough. Come back when the road wears you down again. It always does.',
    options: [
      { text: 'Maybe another time.', nextDialogId: 'start' },
      { text: 'Actually, something else.', nextDialogId: 'services' },
    ],
  },
];
